export const customEncodeURI = (input: string): string => {
  const allowedCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.!~*\'()';

  return input
    .split('')
    .map((char) => {
      if (allowedCharacters.indexOf(char) !== -1) {
        return char;
      } else {
        const charCode = char.charCodeAt(0);
        if (charCode <= 255) {
          return '%' + charCode.toString(16).toUpperCase().padStart(2, '0');
        } else {
          return encodeURIComponent(char).toUpperCase();
        }
      }
    })
    .join('');
}

export const customDecodeURI = (input: string): string => {
    return input.replace(/%[0-9A-Fa-f]{2}|./g, (match) => {
        if (match[0] === '%') {
            return String.fromCharCode(parseInt(match.substr(1), 16));
        } else {
            return match;
        }
    });
}
